import { Button, OdinIcon, OdinIconSize } from '@myosh/odin-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiLogger } from '../../../hooks/use-api-logger';
import { trackErrorBoundaryCrash } from '../../../utils/analytics-utils';

// error prop is type any from the library
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const ErrorFallback = (error: any) => {
  const { t } = useTranslation();
  const log = useApiLogger();

  useEffect(() => {
    const errorMessage = error?.error?.message || error?.message;
    if (errorMessage) {
      // Log to API logger
      log('Top level error', { error: errorMessage });

      // Track to Google Analytics for crash correlation and pattern analysis
      trackErrorBoundaryCrash(error?.error ?? error);
    }
  }, [error, log]);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-5">
      <div
        role="alert"
        className="flex flex-col items-center justify-center rounded border border-error bg-mono-1 p-10 text-center text-error shadow-lg"
      >
        <OdinIcon size={OdinIconSize.Large} icon="TriangleAlert" className="pb-4" />
        <h1 className="mb-2 text-2xl font-bold">{t('error-boundary-warning')}</h1>
        {(error?.error?.message || error?.message) && (
          <pre className="mb-4 whitespace-pre-wrap break-words text-primary-1">
            {error?.error?.message ?? error?.message}
          </pre>
        )}
        <div>
          <Button onClick={handleReload} type="primary">
            {t('reload')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
